module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-images"
  }, [_c('gallery', {
    attrs: {
      "images": _vm.images
    },
    on: {
      "changeIndex": function($event) {
        return _vm.changeImg($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    ref: "lightbox",
    staticClass: "lightbox",
    on: {
      "click": function($event) {
        _vm.isShow = !_vm.modalclose
      }
    }
  }, [_c('fancybox', {
    ref: "fancybox",
    attrs: {
      "images": _vm.images,
      "index": _vm.index,
      "reset": !_vm.isShow,
      "is-show": _vm.isShow,
      "showplaybutton": _vm.showplaybutton,
      "showfullbutton": _vm.showfullbutton,
      "showclosebutton": _vm.showclosebutton,
      "showcaption": _vm.showcaption,
      "showcaptionurl": _vm.showcaptionurl,
      "imagecountseparator": _vm.imagecountseparator,
      "showimagecount": _vm.showimagecount
    },
    on: {
      "play": _vm.playImg,
      "pause": _vm.pauseImg,
      "close": _vm.closeImg,
      "addIndex": _vm.nextImg,
      "decIndex": _vm.prevImg
    }
  }), _vm._v(" "), _c('paginator', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showthumbnails),
      expression: "showthumbnails"
    }],
    attrs: {
      "images": _vm.images,
      "activeIndex": _vm.index
    },
    on: {
      "changeIndex": function($event) {
        return _vm.changeImg($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f73e274"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/components/images/lightbox.vue
// module id = 561
// module chunks = 0